import I3AssetType = ToroEnums.I3AssetType;

import * as moment from 'moment';
import { ToroEnums } from '../../../common/enumerations/toro.enums';

export class I3AssetsOperatingStatus
{
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.assetsModel) this.assetsModel = json.assetsModel.map(a => new I3OperatingStatusAsset(a));
        }
    }

    public assetsModel : I3OperatingStatusAsset[] = [];
}

export class I3OperatingStatusAsset
{
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.createdDate) this.createdDate = moment.utc(json.createdDate).toDate();
            if (json.updatedDate) this.updatedDate = moment.utc(json.updatedDate).toDate();
        }
    }

    id: number;
    assetCode: string;
    entityId: number;
    locationId: number;
    groupId: number;
    assetTypeId: I3AssetType;
    model: string;
    description: string;
    serialNumber: string;
    maintenanceDueCount: number;
    workOrderCount: number;
    utilizationTypeId: I3AssetType;
    utilizationYearToDate: number;
    deviceEsn: string;
    operationalStatus: string;
    faultCodeCount: number;
    latitude: number;
    longitude: number;
    hours: number;
    isDown: boolean;
    createdBy: string;
    updatedBy: string;
    createdDate: Date;
    updatedDate: Date;
    isDeleted: boolean;
}
